/* eslint-disable import/no-default-export */
// 参数
const DEFAULT_PARAMS = {
  ignore: false // 特殊情况跳过
}
// 由于dom层级可能导致mask之类的z-index失效，故将dom移动到body
const directive = {
  install: Vue => {
    Vue.directive('domMove', {
      inserted: function (el, bindings, vnode) {
        el.$domMoveParams = Object.assign({}, DEFAULT_PARAMS, bindings.value)

        if (el.$domMoveParams.ignore) {
          return
        }

        // default append to <body>
        var container
        if (bindings.arg) {
          container = document.getElementById(bindings.arg)
        } else if (el.$domMoveParams.target) {
          container = document.querySelector(el.$domMoveParams.target)
        }
        container = container || document.body

        if (container) {
          bindings.modifiers.prepend && container.firstChild
            ? container.insertBefore(el, container.firstChild) // top of target
            : container.appendChild(el) // bottom of target
        } else {
          console.warn(
            'v-' +
              bindings.name +
              ' target element id "' +
              bindings.arg +
              '" not found.'
          )
        }
      },
      unbind: function (el) {
        if (el.$domMoveParams.ignore) {
          return
        }
        // 可能有动画
        setTimeout(() => {
          if (el.parentNode) {
            el.parentNode.removeChild(el)
          }
        }, 500)
      }
    })
  }
}

export default directive
